const endpoint = process.env.REACT_APP_API_ENDPOINT ?? "";

const loginEndpoint = `${endpoint}/api/auth/samlLogin` ?? "/api/auth/samlLogin";
const logoutEndpoint = `${endpoint}/api/auth/samlLogout` ?? "/api/auth/samlLogout";
const samlLoginEndpoint = `${endpoint}/api/auth/samlLogin` ?? "/api/auth/samlLogin";
const samlLogoutEndpoint = `${endpoint}/api/auth/samlLogout` ?? "/api/auth/samlLogout";
const proxyLogoutEndpoint = `${endpoint}/api/auth/endProxySession` ?? "/api/auth/endProxySession";

export const getCurrentUrl = () => {
  return window.location.href;
};

export const getCurrentDomain = () => {
  return window.location.protocol + '//' + window.location.host;
}

export const getCurrentUrlWithoutPath = () => {
  return window.location.href.split("?")[0].split("/").slice(0, -1).join("/")
};

export const getLoggedOutEndpoint = () => {
  return (
    getCurrentDomain() +
    "/home?action=logout"
  );
};

export const getApplyEndpoint = () => {
  return (
    window.location.href.split("?")[0].split("/").slice(0, -1).join("/") +
    "/apply"
  );
};

export const getCurrentEndpoint = () => {
  return (
    window.location.href.split("?")[0].split("/").slice(0, -1).join("/") +
    "/apply"
  );
};

export const getLoginEndPoint = (callBackUrl) => {
  return `${loginEndpoint}?callback=${callBackUrl}`;
};

export const getLogoutEndPoint = (callBackUrl) => {
  return `${logoutEndpoint}?callback=${callBackUrl}`;
};

export const getSamlLoginEndPoint = (callBackUrl) => {
  return `${samlLoginEndpoint}?callback=${callBackUrl}`;
};

export const getSamlLogoutEndPoint = (callBackUrl) => {
  return `${samlLogoutEndpoint}?callback=${callBackUrl}`;
};

export const getProxyLogoutEndPoint = (applicationId) => {
  return applicationId 
    ? `${proxyLogoutEndpoint}?applicationId=${applicationId}`
    : `${proxyLogoutEndpoint}`;
};

export const endProxyAndRedirect = async (applicationId, programId) => {
    let internalPortalUrl = process.env.REACT_APP_INTERNAL_PORTAL_URL;
    let targetUrl;
    if (applicationId) {
        targetUrl = `${internalPortalUrl}/summary/${applicationId}`;
    } else if (programId) {
        targetUrl = `${internalPortalUrl}/workspace/${programId}`;
    } else {
        targetUrl = `${internalPortalUrl}/workspace`;
    }

    try {
        // Send the kill signal in the background
        await fetch(getProxyLogoutEndPoint(applicationId), {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
            redirect: 'manual'
        });
    } catch (error) {
        console.error("Session termination network error, forcing redirect.", error);
    } finally {
        //React forces the redirect
        window.location.href = targetUrl;
    }
};